import React, { 
  useState, 
  useEffect 
} from 'react'
import { Outlet } from 'react-router-dom'
import { 
  Layout as AntdLayout, 
  Image, 
  Button, 
  Space, 
  Drawer, 
  theme 
} from 'antd'
import { 
  MenuFoldOutlined, 
  MenuUnfoldOutlined 
} from '@ant-design/icons'
import { 
  useNavigate 
} from 'react-router-dom'
import { Menu } from 'basecomps'

const { 
  Header, 
  Sider, 
  Content 
} = AntdLayout

export const Layout = props => {

  const navigate = useNavigate()

  const { title } = window.playmotiv.game
  const [isSidebarVisible, showMenu] = useState(false)
  const {
    token: { 
      colorBgContainer,
      colorPrimary
    }
  } = theme.useToken()

  return (
    <AntdLayout className="main-layout">

      <Drawer
        className="side-bar"
        placement='left'
        open={isSidebarVisible}
        width={300}
        onClose={() => showMenu(false)}
      >

        <div className="logo">
          <Image src={playmotiv.logo} 
                preview={false} 
                style={{
                  margin: 'auto'
                }}/>
        </div>

        <Menu className="side-menu"
          slug="side-menu"
          mode="inline"
          theme="light"
          onClick={() => showMenu(false)} />
          
      </Drawer>

      <AntdLayout>

        <Header className="header" style={{ padding: 0, background: colorBgContainer }}>

          <Button
            type="text"
            icon={ 
              window.playmotiv.game.insignia ?
              <img src={ window.playmotiv.game.insignia } />
              :
              isSidebarVisible ? 
                <MenuFoldOutlined /> 
                : 
                <MenuUnfoldOutlined /> 
            }
            onClick={() => showMenu(!isSidebarVisible)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
              outline: 'none',
              zIndex: 99
            }}
          />
          <div 
            className="game-title" 
            style={{color: colorPrimary}}
            onClick={ () => navigate('/') }
          >
            { 
              props.titlecomp ?
              <props.titlecomp />
              :
              title
            }
          </div>

          { props.header && props.header.left ? props.header.left : <></> }
        </Header>

        <Content className="content-wrapper">

          { props.background && props.background ? props.background : <></> }

          <Outlet />

        </Content>

      </AntdLayout>

    </AntdLayout>
  )
}